import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES, LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { UserStatus } from "../User/models/UserStatus";
import { UserService } from "../User/services/UserService";
import {
  AGENDA_CONSTANTS,
  CALENDAR_TYPE,
  CONFIGURATIONS,
  CONFIMARTION_MODAL_CONTANTS,
  DOCTOR_PROFILE_ACCESS,
  DOCTOR_PROFILE_CONSTANTS
} from "./constants/DoctorProfileConstants";
import { AppointmentItem, AppointmentResponse } from "./models/AppointmentItem";
import { DoctorProfileService } from "./services/DoctorProfileService";
import EventInfoModal from "./components/EventInfoModal/EventInfoModal.vue";
import { Response } from "@/shared/models/Response";
import { CalendarEventModel } from "./models/CalendarEventModel";
import { AvailabilityEvent } from "../Availability/models/AvailabilityEventModel";
import {
  AVAILABILITY_CONSTANTS,
  AVAILIABILITY_ACCESS,
  DEFAULT_SCROLL_TO_TIME
} from "../Availability/constants/AvailabilityConstants";
import { AvailabilityService } from "../Availability/services/AvailabilityService";
import { AvailabilityFilterDetailed } from "../Availability/models/AvailabilityFilterDetailed.model";
import { AvailabilityModel } from "../Availability/models/AvailabilityModel";
import { AxiosError } from "axios";
import { USER_ACCESS } from "../User/constants/UserConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { Utils } from "../../shared/utils/utils";
import { MEDICAL_APPOINTMENT_STATES } from "../MedicalAppointment/constants/MedicalAppointmentConstants";
import { SOCKET_TOPICS } from "@/shared/constants/GeneralConstants";
import { AES, enc } from "crypto-js";

@Component({
  name: "DoctorProfile",
  components: {
    EventInfoModal,
    ModalTemplate
  }
})
export default class DoctorProfile extends Vue {
  @Inject() userService!: UserService;
  @Inject() doctorProfileService!: DoctorProfileService;
  @Inject() availabilityService!: AvailabilityService;

  WELCOME_TITLE = DOCTOR_PROFILE_CONSTANTS.BANNER.WELCOME_TITLE;
  WELCOME_TEXT = DOCTOR_PROFILE_CONSTANTS.BANNER.WELCOME_TEXT;
  TODAY = DOCTOR_PROFILE_CONSTANTS.TEXTS.TODAY;
  VIEW_TYPES = CONFIGURATIONS.VIEW_TYPES;
  MORE_EVENTS = DOCTOR_PROFILE_CONSTANTS.EVENTS;
  COLOR_OPACITY = AVAILABILITY_CONSTANTS.CONFIGURATIONS.COLOR_OPACITY;

  vSheetClass = STYLE_CLASSES.V_SHEET;
  cardClass = STYLE_CLASSES.CARD;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  userId!: string;
  userInfo: UserStatus = {
    id: "",
    userEmail: "",
    userPhone: "",
    userName: "",
    userState: "",
    name: ""
  };

  datePickerValue = "";
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  currentDate: any;
  events: CalendarEventModel[] = [];
  openDialog = false;
  currentChosenEvent: CalendarEventModel = new CalendarEventModel();
  type = "day";
  fetchAppointments = true;
  loadingEvents = false;
  confirmationDialog = false;
  modalConfirmationText = "";
  modalConfirmationTitle = "";
  redirectID = "";
  startFilter = 0;
  endFilter: number | undefined = 0;

  filter: AvailabilityFilterDetailed = {
    start: "",
    end: "",
    name: "",
    space: [],
    campus: [],
    service: [],
    status: [],
    responsable: [this.userId]
  };

  mounted() {
    this.initialCalendarScrollToTime();
    this.checkUser();
    const date = new Date();
    this.currentDate = {
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate()
    };
    this.datePickerValue = `${this.currentDate.year}-${this.currentDate.month +
      1}-${this.currentDate.day}`;

    this.initListener();
  }
  initListener() {
    this.$socket.$subscribe(
      SOCKET_TOPICS.MEDICALAPPOINTMENT_CHANGED,
      this.processAppointmentPayload
    );
    this.$socket.$subscribe(
      SOCKET_TOPICS.AVAILABILITY_CHANGED,
      this.processAvailabilityPayload
    );
  }

  processAppointmentPayload(payload: string) {
    const payloadBytes = AES.decrypt(
      payload,
      process.env.VUE_APP_TOKEN_SECRET as string
    );
    const medicalData = payloadBytes.toString(enc.Utf8);
    const data: AppointmentItem = JSON.parse(medicalData);
    const validate = this.validateMedicalAppointment(data);
    if (validate) {
      const appointment = this.formatAppointmentItem(data);

      const indexAppointment = this.events.findIndex(
        data => data.id == appointment.id
      );
      if (indexAppointment != -1) {
        this.events.splice(indexAppointment, 1);
      } else {
        const indexKey = this.events.findIndex(
          data =>
            data.key == appointment.key &&
            data.start.getTime() == appointment.start.getTime() &&
            data.end.getTime() == appointment.end.getTime() &&
            data.state == AGENDA_CONSTANTS.AVAILABLE
        );
        if (indexKey != -1) {
          this.events.splice(indexKey, 1);
        }
      }
      this.events.push(appointment);
    }
  }
  validateMedicalAppointment(appointment: AppointmentItem) {
    const user = localStorage.getItem(LOCAL_STORAGE.UID) || "";
    if (!appointment.doctor?.includes(user)) return false;
    if (appointment.start < this.startFilter) return false;
    if (this.endFilter && appointment.end > this.endFilter) return false;
    return true;
  }

  processAvailabilityPayload(payload: string) {
    const payloadBytes = AES.decrypt(
      payload,
      process.env.VUE_APP_TOKEN_SECRET as string
    );
    const medicalData = payloadBytes.toString(enc.Utf8);
    const data: AvailabilityModel = JSON.parse(medicalData);
    const validate = this.validatesAvailability(data);
    if (validate) {
      const eventFilters = (data.events as AvailabilityEvent[]).filter(
        event =>
          event.start >= this.startFilter &&
          ![
            AGENDA_CONSTANTS.RESERVED,
            MEDICAL_APPOINTMENT_STATES.CANCELED
          ].includes(event.status) &&
          this.endFilter &&
          event.end <= this.endFilter
      );
      const availabilityId = data.id || "";

      const eventsReserved = this.events.filter(
        event =>
          [
            MEDICAL_APPOINTMENT_STATES.ASSIGNED,
            MEDICAL_APPOINTMENT_STATES.CANCELED,
            MEDICAL_APPOINTMENT_STATES.COMPLETED
          ].includes(event.state) || event.availability.id != availabilityId
      );

      const availabilityEvents = eventFilters.map(event => {
        const availabilityEvent = this.formatAvailabilityEvent(
          availabilityId,
          event
        );
        return availabilityEvent;
      });

      this.events = [...eventsReserved, ...availabilityEvents];
    }
  }

  validatesAvailability(availability: AvailabilityModel) {
    const user = localStorage.getItem(LOCAL_STORAGE.UID) || "";
    if (
      !availability.responsable ||
      !((availability.responsable || []) as string[]).includes(user)
    )
      return false;
    return true;
  }

  initialCalendarScrollToTime() {
    if (this.$refs && this.$refs.calendar) {
      const scroll = this.$refs.calendar as Vue & {
        scrollToTime: (data: string) => void;
      };
      if (scroll.scrollToTime) {
        scroll.scrollToTime(DEFAULT_SCROLL_TO_TIME);
      }
    }
  }

  @Watch("$route.params.id")
  async checkUser() {
    if (this.$route.params.id) {
      this.userId = this.$route.params.id;
      await this.getUserData();
    } else {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.$router.push("/");
    }
  }

  @Watch("type")
  async checkType() {
    if (this.fetchAppointments) {
      await this.checkDatePickerValue();
    } else {
      this.fetchAppointments = true;
    }
  }

  formatYearMonthDay(dateToTransform: Date) {
    const dayToStr = String(dateToTransform.getDate());
    const monthToStr = String(dateToTransform.getMonth() + 1);
    const [monthFormat, dayFormat, yearFormat] = [
      !(monthToStr.length > 1) ? "0" + monthToStr : monthToStr,
      !(dayToStr.length > 1) ? "0" + dayToStr : dayToStr,
      String(dateToTransform.getFullYear())
    ];

    return yearFormat + "-" + monthFormat + "-" + dayFormat;
  }

  getListOfUserEvents(userEvents: AvailabilityModel[]) {
    let otherEvents: CalendarEventModel[] = [];
    if (userEvents.length > 0) {
      userEvents?.forEach(availability => {
        const extraEvents = Object.keys(availability.events).map(eventDuple => {
          const eventData = availability.events[eventDuple];
          const medicalAppointment = eventData?.medicalAppointment;
          const [startEvent, endEvent] = eventDuple.split("-");
          const start = new Date(+startEvent);
          const end = new Date(+endEvent);
          const event = new CalendarEventModel();
          const patientName =
            medicalAppointment?.patient?.name &&
            medicalAppointment?.patient?.name !== ""
              ? medicalAppointment?.patient?.name
              : availability.status;
          event.patient = {
            id: medicalAppointment?.patient?.id,
            name: patientName,
            document: medicalAppointment?.patient?.document
          };
          event.campus = {
            id: medicalAppointment?.campus?.id,
            name: medicalAppointment?.campus?.name,
            address: medicalAppointment?.campus?.address
          };
          event.name = eventData.eventTitle;
          event.start = start;
          event.end = end;
          event.service = eventData.service;
          if (eventData.status != AGENDA_CONSTANTS.AVAILABLE) {
            event.service.state = AGENDA_CONSTANTS.BUSY;
          }
          if (eventData.status === AGENDA_CONSTANTS.AVAILABLE) {
            event.color =
              availability.color ?? AGENDA_CONSTANTS.AVAILABLE_COLOR;
          } else {
            event.color = AGENDA_CONSTANTS.BLOCKED_COLOR;
          }
          if (medicalAppointment) {
            event.color = Utils.changeColorOpacity(
              medicalAppointment.eventColor,
              this.COLOR_OPACITY
            );
          }
          event.timed = true;
          return event;
        });

        otherEvents = [...otherEvents, ...extraEvents];
      });
      return otherEvents;
    }
    return [];
  }

  @Watch("datePickerValue")
  async checkDatePickerValue() {
    try {
      this.loadingEvents = true;
      this.events = [];
      if (this.fetchAppointments) {
        const start = this.transformDatePickerDateIntoValidOne(
          this.datePickerValue
        );
        /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
        let result: any;

        if (this.type === CALENDAR_TYPE.DAY) {
          result = this.calculateDayRange(start);
        } else if (this.type === CALENDAR_TYPE.WEEK) {
          result = this.calculateWeekRange(start);
        } else if (this.type === CALENDAR_TYPE.MONTH) {
          result = this.calculateMonthRange(start);
        }
        const response = await this.getAgenda(result.start, result.end);

        if (response?.data) {
          this.events = await this.updateEvents(response.data);
        }
        this.initialCalendarScrollToTime();
        this.loadingEvents = false;
      } else {
        this.fetchAppointments = true;
      }

      if (this.events.length === 0) {
        Snackbar.popInfo(DOCTOR_PROFILE_CONSTANTS.BANNER.NO_EVENTS_FOUND);
        this.loadingEvents = false;
      }
    } catch (error) {
      this.loadingEvents = false;
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + AVAILIABILITY_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getAgenda(
    start: Date,
    end?: Date
  ): Promise<Response<AppointmentResponse> | null> {
    try {
      this.startFilter = start.getTime();
      this.endFilter = end?.setHours(23, 59, 59);
      const responseData = await this.doctorProfileService.getAppointmentList(
        this.startFilter,
        this.endFilter
      );

      return responseData;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DOCTOR_PROFILE_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return null;
    }
  }

  async getUserData() {
    try {
      const responseData = await this.userService.getUserBasicInfo(this.userId);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userInfo = responseData.data;
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async updateEvents(data: AppointmentResponse): Promise<CalendarEventModel[]> {
    const events: CalendarEventModel[] = [];
    if (data.medicalAppointmentList?.length > 0) {
      data.medicalAppointmentList.forEach(item => {
        const event = this.formatAppointmentItem(item);
        events.push(event);
      });
    }

    if (data.unbookedEventsList?.ok) {
      Object.entries(data.unbookedEventsList.events).forEach(a => {
        if (a[1].length > 0) {
          (a[1] as Array<AvailabilityEvent>).forEach(unbooked => {
            const event = this.formatAvailabilityEvent(a[0], unbooked);
            events.push(event);
          });
        }
      });
    }

    return events;
  }

  formatAppointmentItem(appointment: AppointmentItem) {
    const start = new Date(appointment.start);
    const end = new Date(appointment.end);
    const event = new CalendarEventModel();
    event.id = appointment.id;
    event.key = `${appointment.availability.id}-${appointment.eventKey}`;
    event.name = appointment.name;
    event.start = start;
    event.end = end;
    event.timed = true;
    event.campus = appointment.campus;
    event.patient = appointment.patient;
    event.service = appointment.service;
    event.availability = appointment.availability;
    event.state = appointment.state;
    if (
      [
        MEDICAL_APPOINTMENT_STATES.ASSIGNED,
        MEDICAL_APPOINTMENT_STATES.COMPLETED
      ].includes(appointment.state)
    ) {
      event.color = appointment.color || AGENDA_CONSTANTS.RESERVED_COLOR;
    }
    if (appointment.state == MEDICAL_APPOINTMENT_STATES.CANCELED) {
      event.color = AGENDA_CONSTANTS.CANCEL_COLOR;
      event.service = {
        ...appointment.service,
        id: "",
        state: AGENDA_CONSTANTS.CANCEL
      };
    }
    return event;
  }
  formatAvailabilityEvent(id: string, availability: AvailabilityEvent) {
    const start = new Date(availability.start);
    const end = new Date(availability.end);
    const event = new CalendarEventModel();
    event.patient = {
      id: "",
      name: availability.status,
      document: ""
    };
    event.availability = { id };
    event.key = `${id}-${availability._key}`;
    event.name = this.formatEventName(start);
    event.start = start;
    event.end = end;
    event.color =
      availability.status == AGENDA_CONSTANTS.BLOCKED
        ? AGENDA_CONSTANTS.BLOCKED_COLOR
        : availability.color
        ? Utils.changeColorOpacity(availability.color, this.COLOR_OPACITY)
        : AGENDA_CONSTANTS.AVAILABLE_COLOR;
    event.timed = true;
    event.service.state = availability.status;
    event.service.name = availability.name;
    event.state = availability.status;
    return event;
  }

  getEventColor(event: CalendarEventModel) {
    return event.color;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  getEventName(eventCalendar: any) {
    return eventCalendar.input.patient.name;
  }

  setToday() {
    this.datePickerValue = `${this.currentDate.year}-${this.currentDate.month +
      1}-${this.currentDate.day}`;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  showEvent({ event }: any) {
    this.openDialog = true;
    this.currentChosenEvent = event;
  }

  closeModal() {
    this.openDialog = false;
  }

  openService(event: CalendarEventModel) {
    this.redirectID = `${event.patient?.id}/${event.service?.id}`;
    this.modalConfirmationTitle = CONFIMARTION_MODAL_CONTANTS.SERVICIO_TITLE;
    this.modalConfirmationText = CONFIMARTION_MODAL_CONTANTS.MESSAGE;
    this.confirmationDialog = true;
  }

  openMedicalHistory(patientID: string) {
    this.redirectID = `${patientID}`;
    this.modalConfirmationTitle = CONFIMARTION_MODAL_CONTANTS.PROFILE_TITLE;
    this.modalConfirmationText = CONFIMARTION_MODAL_CONTANTS.MESSAGE;
    this.confirmationDialog = true;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  viewDay(date: any) {
    if (this.type === CALENDAR_TYPE.MONTH || this.type === CALENDAR_TYPE.WEEK) {
      this.fetchAppointments = false;
    }
    Vue.nextTick(() => {
      this.datePickerValue = date.date;
    });
    this.type = CALENDAR_TYPE.DAY;
  }

  calculateDayRange(start: Date) {
    start.setHours(0, 0, 0);
    const end = new Date(start.getTime());
    end.setHours(23, 59, 59);

    return { start, end };
  }

  calculateWeekRange(start: Date) {
    const WEEK_DAYS = 7;
    const weekDay = start.getDay();

    const firstWeekDay = start.getDate() - weekDay;
    const lastWeekDay = start.getDate() - weekDay + (WEEK_DAYS - 1);

    const end = new Date(start.getTime());
    start.setDate(firstWeekDay);
    end.setDate(lastWeekDay);

    return { start, end };
  }

  calculateMonthRange(start: Date) {
    start.setDate(1);

    const end = new Date(start.getTime());
    end.setMonth(start.getMonth() + 1);
    end.setDate(1);

    return { start, end };
  }

  transformDatePickerDateIntoValidOne(date: string) {
    const splittedDate = date.split("-");
    const year = Number.parseInt(splittedDate[0]);
    const month = Number.parseInt(splittedDate[1]) - 1;
    const day = Number.parseInt(splittedDate[2]);

    return new Date(year, month, day);
  }

  capitalizeMonths(monthName: string): string {
    if (monthName !== undefined) {
      const capitalizedFirstLetter = monthName.charAt(0).toUpperCase();
      const monthNameFromSecondLetter = monthName.slice(1);
      const capitalizedMonth = `${capitalizedFirstLetter}${monthNameFromSecondLetter}`;
      return capitalizedMonth;
    }
    return "";
  }

  formatEventName(date: Date) {
    const day = date.getDay();
    const month = date.getMonth();
    const hour = date.getHours() % 12;
    const minute = date.getMinutes();
    const seconds = date.getSeconds();
    return `${day < 10 ? "0" + day : day}/${
      month < 10 ? "0" + month : month
    }/${date.getFullYear()}, ${hour < 10 ? "0" + hour : hour}:${
      minute < 10 ? "0" + minute : minute
    }:${seconds < 10 ? "0" + seconds : seconds} ${
      date.getHours() / 12 < 1 ? " a. m" : "p. m"
    }`;
  }
  confirmationAccept() {
    this.confirmationDialog = false;
    if (
      this.modalConfirmationTitle ===
        CONFIMARTION_MODAL_CONTANTS.PROFILE_TITLE ||
      this.modalConfirmationTitle === CONFIMARTION_MODAL_CONTANTS.SERVICIO_TITLE
    ) {
      this.$router.push(`/profile/${this.redirectID}`);
    }
  }

  confirmationCancel() {
    this.confirmationDialog = false;
  }
}
